/**
 * GN — galleria prodotto infinita anche col dito.
 * Le frecce di Horizon già girano (attributo infinite), ma lo scorrimento nativo finiva all'ultima foto.
 * Si aggiungono due copie ai bordi (ultima foto prima della prima, prima foto dopo l'ultima): trascinando
 * oltre il bordo la foto successiva arriva sotto il dito senza interruzioni. Quando lo scorrimento si ferma
 * su una copia si passa all'originale senza animazione (stessa immagine, salto invisibile) e Horizon
 * risincronizza pallini e contatore. Le copie non hanno ref, quindi Horizon non le conta.
 */
const CLONE = 'data-gn-loop-clone';

const isSlide = (el) => el.localName === 'slideshow-slide';
const realSlides = (scroller) => [...scroller.children].filter((el) => isSlide(el) && !el.hasAttribute(CLONE) && !el.hasAttribute('hidden'));
const centerOf = (el, scroller) => el.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft + el.offsetWidth / 2;
const jump = (scroller, left) => scroller.scrollTo({ left, behavior: 'instant' });

function makeClone(slide) {
  const clone = slide.cloneNode(true);
  clone.setAttribute(CLONE, '');
  clone.setAttribute('aria-hidden', 'true');
  clone.removeAttribute('ref');
  clone.inert = true;
  clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
  clone.querySelectorAll('[ref]').forEach((n) => n.removeAttribute('ref'));
  clone.querySelectorAll('img').forEach((img) => {
    img.loading = 'lazy';
    img.removeAttribute('fetchpriority');
  });
  return clone;
}

// Copie presenti e al loro posto; se la galleria mostra più foto insieme (desktop a griglia) niente copie
function ensure(scroller) {
  const slides = realSlides(scroller);
  const clones = scroller.querySelectorAll(`:scope > [${CLONE}]`);
  const single = slides.length > 1 && slides[0].offsetWidth >= scroller.clientWidth * 0.8;
  const inPlace = clones.length === 2 && scroller.firstElementChild?.hasAttribute(CLONE) && scroller.lastElementChild?.hasAttribute(CLONE);
  if (single && inPlace) return;
  // La foto visibile non deve cambiare. Di solito ci pensa il browser (lo scroll snap resta agganciato
  // alla stessa foto); se non lo fa, si riporta lì nello stesso frame, senza animazione.
  const viewCenter = () => scroller.scrollLeft + scroller.clientWidth / 2;
  const anchor = slides.find((s) => Math.abs(centerOf(s, scroller) - viewCenter()) < s.offsetWidth / 2) || slides[0];
  clones.forEach((c) => c.remove());
  if (single) {
    scroller.prepend(makeClone(slides[slides.length - 1]));
    scroller.append(makeClone(slides[0]));
  }
  const drift = anchor ? centerOf(anchor, scroller) - viewCenter() : 0;
  if (Math.abs(drift) > 1) jump(scroller, scroller.scrollLeft + drift);
}

function setup(show) {
  const scroller = [...show.querySelectorAll('slideshow-slides')].find((s) => s.closest('slideshow-component') === show);
  if (!scroller || scroller.dataset.gnLoop) return;
  scroller.dataset.gnLoop = '1';
  ensure(scroller);

  let touching = false;
  let timer;
  const settle = () => {
    if (touching || show.hasAttribute('dragging')) return;
    const all = [...scroller.children].filter(isSlide);
    const mid = scroller.scrollLeft + scroller.clientWidth / 2;
    const near = all.reduce((a, b) => (Math.abs(centerOf(b, scroller) - mid) < Math.abs(centerOf(a, scroller) - mid) ? b : a));
    if (!near?.hasAttribute(CLONE)) return;
    const slides = realSlides(scroller);
    const target = near === scroller.firstElementChild ? slides[slides.length - 1] : slides[0];
    jump(scroller, scroller.scrollLeft + target.offsetLeft - near.offsetLeft);
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(settle, 120);
  };
  scroller.addEventListener('touchstart', () => (touching = true), { passive: true });
  scroller.addEventListener('touchend', () => { touching = false; schedule(); }, { passive: true });
  scroller.addEventListener('scroll', schedule, { passive: true });

  // Cambio variante: Horizon ri-sincronizza il markup e toglie le copie, si rimettono
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; ensure(scroller); });
  }).observe(scroller, { childList: true });
  new ResizeObserver(() => ensure(scroller)).observe(scroller);
}

customElements.whenDefined('slideshow-component').then(() => {
  document.querySelectorAll('media-gallery slideshow-component[infinite]').forEach((show) => {
    if (!show.closest('dialog')) setup(show);
  });
});
